import { render } from "./PlaceBox.vue?vue&type=template&id=7a4b1dfe&scoped=true&ts=true"
import script from "./PlaceBox.vue?vue&type=script&lang=ts"
export * from "./PlaceBox.vue?vue&type=script&lang=ts"

import "./PlaceBox.vue?vue&type=style&index=0&id=7a4b1dfe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a4b1dfe"]])

export default __exports__